// src/components/TitleBlock.tsx
import React from 'react';
import './TitleBlock.scss';

interface Props {
  title: string;
  date: string;
}

const TitleBlock: React.FC<Props> = ({ title, date }) => (
  <section className="title-block">
    <h2>{title}</h2>
    <span>{date}</span>
  </section>
);

export default TitleBlock;

